module.exports = __webpack_public_path__ + "media/application/images/2023/01_still-1920x1080-308328ea1b281a3f2109dc99f2f46976.png";